import ACTION_TYPES from '../../constants/actionTypes';
import merge from 'lodash/merge';
import BOAPlansStub from '../../constants/planResponseStub';

export default {
  quotes(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.CREATE_QUOTE_SUCCESS:
      case ACTION_TYPES.UPDATE_QUOTE_SUCCESS:
      case ACTION_TYPES.FINALIZE_QUOTE_SUCCESS:
      case ACTION_TYPES.GET_QUOTE_SUCCESS:
        return {
          ...state,
          [action.payload.quote_number]: action.payload,
        };
      case ACTION_TYPES.GET_QUOTES_SUCCESS:
        return {
          ...action.payload.reduce((acc, quote) => {
            acc[quote.quote_number] = quote;
            return acc;
          }, {}),
        };
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return {};
      default:
        return state;
    }
  },

  fetchedQuoteId(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.CREATE_QUOTE_SUCCESS:
        return action.payload.quote_number;
      default:
        return state;
    }
  },

  plans(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.GET_PLANS_SUCCESS:
        if (
          action.payload.plans[0] &&
          action.payload.plans[0].plan_type === 'chubb_boa'
        ) {
          // XXX: Use stubbed plans response until second plan is added to BOA
          return [merge({}, BOAPlansStub.plans[0], action.payload.plans[0])];
        } else return action.payload.plans;
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return [];
      default:
        return state;
    }
  },

  plansFilter(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.UPDATE_PLANS_FILTER:
        return merge({}, state, action.payload);
      case ACTION_TYPES.CREATE_QUOTE_SUCCESS:
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return {};
      default:
        return state;
    }
  },

  quoteCheckout(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.CHECKOUT_QUOTE_SUCCESS:
        return action.payload;
      case ACTION_TYPES.CREATE_QUOTE_SUCCESS:
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return {};
      default:
        return state;
    }
  },

  isFetchingQuotes(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_QUOTE:
      case ACTION_TYPES.GET_QUOTES:
        return false;
      case ACTION_TYPES.GET_QUOTE_SUCCESS:
      case ACTION_TYPES.GET_QUOTE_FAILURE:
      case ACTION_TYPES.GET_QUOTES_SUCCESS:
      case ACTION_TYPES.GET_QUOTES_FAILURE:
        return false;
      default:
        return state;
    }
  },

  isCheckingOutQuote(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.UPDATE_QUOTE:
      case ACTION_TYPES.CHECKOUT_QUOTE:
        return true;
      case ACTION_TYPES.CHECKOUT_QUOTE_SUCCESS:
      case ACTION_TYPES.CHECKOUT_QUOTE_FAILURE:
      case ACTION_TYPES.FINALIZE_QUOTE_FAILURE:
        return false;
      default:
        return state;
    }
  },
};
